import React, { useContext } from 'react';
import { array } from 'prop-types';
import { useIntl } from 'react-intl';
import { formatDate } from '@tesla/intl-date-time';
import Title from '../Title';
import { DataContext } from '../../../containers/Search/context';

const List = ({ results }) => {
  const intl = useIntl();
  const api = useContext(DataContext);
  const { locale } = intl;

  return (
    <ol className="tds-list tds-list--small-borders">
      {results &&
        results.map((item) => (
          <li key={item.id} className="tds-list-item">
            <strong>
              <Title id={item.id} title={item.t} />
            </strong>
            <div>{api.lookupDepartment(item.dp)}</div>
            <div>{api.lookupLocation(item.l)}</div>
            {item.pb && <div>{formatDate(Date.parse(item.pb), { format: 'L', locale })}</div>}
          </li>
        ))}
    </ol>
  );
};

List.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  results: array.isRequired,
};

export default List;
